export const USER_TEXT_MAX_LENGTH = 131072;
const NULL_CHARACTER = "\u0000";
export const stripNullCharacters = (value) => value.includes(NULL_CHARACTER) ? value.split(NULL_CHARACTER).join("") : value;
//# sourceMappingURL=user-text.js.map